import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import { createForm } from '@ps/web-shared-ui';
import { FORM_ERROR } from 'final-form';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import useBeforeUnload from '@swf/core/hooks/useBeforeUnload';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import useLogoutUser from '../hooks/useLogoutUser';

import {
  TXTWCL_Kindly_accept_the_new_agreemen_ELL,
  TXTWCL_Something_went_wrongX_please_t_ELL,
  TXTWCL_We_encourage_you_to_take_the_t_ELL,
  TXTWCL_We_have_introduced_amendments__ELL,
  TXTWCL_We_have_introduced_amendments__ELL_1
} from './LoginEulaForm.messages.json';
import type { LoginEulaFormValues } from './LoginEulaFormFields';
import LoginEulaFormFields from './LoginEulaFormFields';

const Form = createForm<LoginEulaFormValues>();

const LoginEulaForm: React.FC = () => {
  const { push } = useHistory();
  const beforeUnload = useBeforeUnload();
  const logout = useLogoutUser();
  const useMailList = useSelector(select.account.getEulaMarketingEnabled);
  const siteId = useSelector(select.cms.getSiteId);

  const {
    auth: { signEula }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    beforeUnload(() => logout());
  }, [logout, beforeUnload]);

  const handleSubmit = async (values: LoginEulaFormValues) => {
    const { marketingMailList } = values;
    if (siteId !== Sites.CA_ON && useMailList && !marketingMailList) {
      push('/auth/login/eula/opt-in');
    } else {
      try {
        await signEula({ marketingMailList, useMailList });
        logout();
      } catch (error) {
        return { [FORM_ERROR]: <Translation {...TXTWCL_Something_went_wrongX_please_t_ELL} /> };
      }
    }
  };

  return (
    <>
      <p>
        {siteId === Sites.ITA ? (
          <Translation {...TXTWCL_We_have_introduced_amendments__ELL_1} />
        ) : (
          <Translation {...TXTWCL_We_have_introduced_amendments__ELL} />
        )}{' '}
        <Translation {...TXTWCL_We_encourage_you_to_take_the_t_ELL} />{' '}
        <Translation {...TXTWCL_Kindly_accept_the_new_agreemen_ELL} />
      </p>
      <Form
        onSubmit={handleSubmit}
        initialValues={{
          selectAll: false,
          Eula: false,
          privacy: false,
          marketingMailList: false
        }}
      >
        <LoginEulaFormFields />
      </Form>
    </>
  );
};

export default LoginEulaForm;
